import { RawFile } from "@mapmycustomers/shared/types/File";

import hasMimeType, { IMAGE_ANY, VIDEO_ANY } from "@app/util/mimeType";

const isMediaFile = (file: RawFile) => hasMimeType(file, [...IMAGE_ANY, ...VIDEO_ANY]);

export default isMediaFile;
